import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        backgroundColor: theme.palette.primary.light,
        borderRadius: '4px',
        padding: '8px',
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    options_container: {
        padding: '10px',
        width: '850px'
    },
    observation_container: {
        marginBottom: '10px'
    },
    inputs_and_btn_container: {
        display: 'flex',
        justifyContent:'space-between',
        gap: '5px',
        marginBottom: '10px',
        alignItems: 'center'
    },
    inputs_container: {
        display: 'flex',
        gap: '5px',
    }
}));

export {useStyles}